import React, { useState } from "react";
import PropTypes from "prop-types";
import { FaEdit, FaEye } from "react-icons/fa";
import "../App.css";

function Table({
  headers,
  data,
  edit,
  Action,
  actionType = "view",
  pagination = true,
  recordsCount,
  detailsAtStart = false,
}) {
  const [currentPage, setCurrentPage] = useState(1);

  const rowsPerPage = Math.max(Number(recordsCount || 5), 5);
  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;

  const currentData = pagination
    ? data.slice(indexOfFirstRow, indexOfLastRow)
    : data;

  const totalPages = pagination ? Math.ceil(data.length / rowsPerPage) : 1;

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const handlePrevious = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  const handleNext = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };
  // const handlePrevious = () =>
  //   currentPage > 1 && setCurrentPage(currentPage - 1);
  // const handleNext = () =>
  //   currentPage < totalPages && setCurrentPage(currentPage + 1);

  const renderTableHeader = () => (
    <thead>
      <tr>
        <th>Sr No</th>
        {headers.map((h, i) => (
          <th key={i}>{h}</th>
        ))}
        {Action && !detailsAtStart && <th>Action</th>}
        {edit && <th>Edit</th>}
      </tr>
    </thead>
  );

  const renderTableBody = () => (
    <tbody>
      {currentData.length === 0 ? (
        <tr>
          <td colSpan={headers.length + 2} className="text-center">
            No Records available
          </td>
        </tr>
      ) : (
        currentData.map((rowData, rowIndex) => {
          const row = Array.isArray(rowData) ? rowData : rowData.row;
          const meta = rowData?._meta || {};
          const isEditDisabled = meta.rfq_status === "12";

          return (
            <tr key={rowIndex}>
              <td>{indexOfFirstRow + rowIndex + 1}</td>

              {row.map((cell, i) => (
                <td key={i} className="truncate-cell">
                  {cell}
                </td>
              ))}

              {Action && !detailsAtStart && (
                <td>
                  {actionType === "edit-view" ? (
                    <>
                      <FaEdit
                        className="greyColor mx-2"
                        style={{
                          cursor: isEditDisabled
                            ? "not-allowed"
                            : "pointer",
                          opacity: isEditDisabled ? 0.4 : 1,
                          pointerEvents: isEditDisabled ? "none" : "auto",
                        }}
                        title={
                          isEditDisabled
                            ? "Closed RFQ cannot be edited"
                            : "Edit"
                        }
                        onClick={() =>
                          !isEditDisabled &&
                          Action.edit(indexOfFirstRow + rowIndex)
                        }
                      />

                      <FaEye
                        className="greyColor mx-2"
                        style={{ cursor: "pointer" }}
                        title="View"
                        onClick={() =>
                          Action.view(indexOfFirstRow + rowIndex)
                        }
                      />
                    </>
                  ) : actionType === "edit" ? (
                    <FaEdit
                      className="greyColor mx-2"
                      style={{ cursor: "pointer" }}
                      onClick={() =>
                        Action(indexOfFirstRow + rowIndex)
                      }
                    />
                  ) : (
                    <FaEye
                      className="greyColor mx-2"
                      style={{ cursor: "pointer" }}
                      onClick={() =>
                        Action(indexOfFirstRow + rowIndex)
                      }
                    />
                  )}
                </td>
              )}

              {edit && (
                <td>
                  <FaEdit
                    className="greyColor mx-2"
                    style={{ cursor: "pointer" }}
                    onClick={() =>
                      edit(indexOfFirstRow + rowIndex)
                    }
                  />
                </td>
              )}
            </tr>
          );
        })
      )}
    </tbody>
  );

  return (
    <div>
      <div className="table-responsive" style={{ maxHeight: 500, overflowY: 'auto' }}>
        <table className="table table-row-spacing table-hover">
          {renderTableHeader()}
          {renderTableBody()}
        </table>
      </div>
      {pagination && totalPages > 1 && (
  <nav
    aria-label="Page navigation example"
    className="d-flex justify-content-center mt-3 flex-wrap"
    style={{ wordWrap: 'break-word' }}
  >
    <ul
      className="pagination d-flex flex-wrap justify-content-center overflow-auto"
      style={{ maxWidth: '100%' }}
    >
      <li className="page-item">
        <button
  className="btn Button primaryColorText btn-outline-secondary m-2"
  onClick={handlePrevious}
  disabled={currentPage === 1}
>
  Previous
</button>

      </li>

 
      <li className={`page-item ${currentPage === 1 ? 'active' : ''}`}>
  <button
    className="btn primaryColorText btn-outline-secondary m-2 p-2 btn-width"
    onClick={() => paginate(1)}
  >
    1
  </button>
</li>


      {currentPage > 3 && (
        <li className="page-item disabled">
          <button className="btn primaryColorText btn-outline-secondary m-2 p-2 btn-width">
            ...
          </button>
        </li>
      )}

  
      {Array.from({ length: 3 }, (_, i) => currentPage - 1 + i)
        .filter((pageNumber) => pageNumber > 1 && pageNumber < totalPages)
        .map((pageNumber) => (
          <li
            key={pageNumber}
            className={`page-item ${
              currentPage === pageNumber ? 'active' : ''
            }`}
          >
            <button
              className="btn primaryColorText btn-outline-secondary m-2 p-2 btn-width"
              onClick={() => paginate(pageNumber)}
            >
              {pageNumber}
            </button>
          </li>
        ))}
      {currentPage < totalPages - 2 && (
        <li className="page-item disabled">
          <button className="btn primaryColorText btn-outline-secondary m-2 p-2 btn-width">
            ...
          </button>
        </li>
      )}

     <li className={`page-item ${currentPage === totalPages ? 'active' : ''}`}>
  <button
    className="btn primaryColorText btn-outline-secondary m-2 p-2 btn-width"
    onClick={() => paginate(totalPages)}
  >
    {totalPages}
  </button>
</li>


      <li className="page-item">
        <button
  className="btn Button primaryColorText btn-outline-secondary m-2"
          onClick={handleNext}
          disabled={currentPage === totalPages}
        >
          Next
        </button>
      </li>
    </ul>
  </nav>
)}





    </div>
  );
}

Table.propTypes = {
  headers: PropTypes.array.isRequired,
  data: PropTypes.array.isRequired,
  edit: PropTypes.func,
  Action: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({
      edit: PropTypes.func,
      view: PropTypes.func,
    }),
  ]),
  actionType: PropTypes.string,
  pagination: PropTypes.bool,
  recordsCount: PropTypes.number,
  detailsAtStart: PropTypes.bool,
};

export default Table;
